var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoData = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 129,
  height: 126,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 61.277,
  cy: 60.777,
  r: 60.777,
  fill: "#F5F8FF"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 61.277,
  cy: 60.777,
  r: 47.271,
  fill: "#BDCDD2",
  fillOpacity: 0.37
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33.155 102.448H89.53a3.655 3.655 0 0 0 3.655-3.655V33.42L77.564 19H33.155a3.655 3.655 0 0 0-3.655 3.655v76.138a3.655 3.655 0 0 0 3.655 3.655Z",
  fill: "#F5F8FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.155 20h44.019l15.01 13.857v64.936a2.655 2.655 0 0 1-2.655 2.655H33.155a2.655 2.655 0 0 1-2.655-2.655V22.655a2.656 2.656 0 0 1 2.384-2.641l.271-.014Z",
  stroke: "#8BA7AB",
  strokeOpacity: 0.53,
  strokeWidth: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.285 37.024c0-1.01.818-1.828 1.828-1.828h35.386a1.828 1.828 0 1 1 0 3.656H39.113a1.828 1.828 0 0 1-1.828-1.828Zm0 11.265c0-1.01.818-1.828 1.828-1.828h45.66a1.828 1.828 0 1 1 0 3.655h-45.66a1.828 1.828 0 0 1-1.828-1.827Zm0 11.265c0-1.01.818-1.828 1.828-1.828h12.556a1.828 1.828 0 1 1 0 3.655H39.113a1.828 1.828 0 0 1-1.828-1.827Zm20.547 0c0-1.01.819-1.828 1.828-1.828h25.113a1.828 1.828 0 1 1 0 3.655H59.66a1.828 1.828 0 0 1-1.828-1.827ZM37.285 70.819c0-1.01.818-1.828 1.828-1.828h33.103a1.828 1.828 0 1 1 0 3.655H39.113a1.828 1.828 0 0 1-1.828-1.827Zm41.094 0c0-1.01.819-1.828 1.828-1.828h4.566a1.828 1.828 0 1 1 0 3.655h-4.566a1.828 1.828 0 0 1-1.828-1.827ZM37.285 80.957c0-1.01.818-1.828 1.828-1.828h42.236a1.828 1.828 0 0 1 0 3.656H39.113a1.828 1.828 0 0 1-1.828-1.828Zm0 10.138c0-1.009.818-1.827 1.828-1.827h30.82a1.828 1.828 0 0 1 0 3.655h-30.82a1.828 1.828 0 0 1-1.828-1.828Z",
  fill: "#8BA7AB",
  fillOpacity: 0.53
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.285 37.024c0-1.01.818-1.828 1.828-1.828h35.386a1.828 1.828 0 1 1 0 3.656H39.113a1.828 1.828 0 0 1-1.828-1.828Z",
  fill: "#547D84"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m77.564 19 15.621 14.42h-11.62a4 4 0 0 1-4-4V19ZM63.415 123.958c21.872 0 39.603-1.035 39.603-2.312s-17.73-2.313-39.603-2.313c-21.872 0-39.602 1.036-39.602 2.313 0 1.277 17.73 2.312 39.602 2.312Z",
  fill: "#8BA7AB",
  fillOpacity: 0.53
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22.919,
  height: 3.951,
  rx: 1.976,
  transform: "scale(-1 1) rotate(45 -115.193 -66.42)",
  fill: "#547D84"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 22.919,
  height: 3.951,
  rx: 1.976,
  transform: "scale(1 -1) rotate(-45 -45.963 -110.255)",
  fill: "#547D84"
})));
export default SvgNoData;